import { render } from "./UserSettings.vue?vue&type=template&id=65a1ce26&scoped=true&ts=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=65a1ce26&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a1ce26"]])

export default __exports__